
import CourseElementModel from './CourseElementModel';

class SequenceBase extends CourseElementModel {

	constructor( json:Object ){
		super( json );
	}
	
	get title():string {
		return this.get<string>( 'title' );
    }
    
    get module():string {
		return this.get<string>( 'module' );	
	}
	
	get time():number {
		return this.get<number>( 'time' );	
	}
	
	set time( t:number ){
		this.set( 'time', t );	
	}

	get done():boolean {
		return this.get<boolean>( 'done', false );
	}

	set done( d:boolean ){
		this.set( 'done', d );
	}
	
}

export default SequenceBase;

